/*
 * @Author: your name
 * @Date: 2020-07-08 14:49:23
 * @LastEditTime: 2020-07-08 14:49:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\utils\index.js
 */
// 两位小数
export const checkNumberFloat = value => {
    // 去掉数字和.以外的内容
    value = value.replace(/[^\d.]/g, '')
    // 不允许.开头
    value = value.replace(/^\./g, '')
    // 去掉连续的.
    value = value.replace(/\.{2,}/g, '.')
    value = value.replace(/^(0+)/g, '0')
    // 只允许一个点，第一个会匹配到第一个点，第二个会匹配到剩余的点
    // 因为是输入框，最多会呈现到‘1.23.’这种方式
    // 注意第一个点是字符串方式匹配，第二个是正则匹配
    value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    // 两位小数，‘\.(\d\d)’匹配到两位数
    value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    return value
}
